// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"588":"d2c70baf","787":"0f2a79eb","845":"52474bf9","855":"9b8174ee"}[chunkId] + ".chunk.js";
};